import { ScreeningStatus } from '@estercare/ester-shared'
import { CONTENTFUL_ENTRY_IDS, ContentfulEntryId } from '../constants/contentfulEntries'

const BANNER_BY_SCREENING_STATUS: Record<ScreeningStatus, ContentfulEntryId> = {
  [ScreeningStatus.NOT_STARTED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_SCREENING,
  [ScreeningStatus.INCOMPLETE]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_SCREENING,
  [ScreeningStatus.RENEW]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_SCREENING,
  [ScreeningStatus.PENDING]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_HEALTH_PLAN_PENDING,
  [ScreeningStatus.HANDLED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_HEALTH_PLAN_READY,
  [ScreeningStatus.CHECK_IN_NOT_STARTED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_CHECK_IN,
  [ScreeningStatus.CHECK_IN_INCOMPLETE]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_CHECK_IN,
  [ScreeningStatus.CHECK_IN_PENDING]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_CHECK_IN,
  [ScreeningStatus.CHECK_IN_HANDLED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_CONTINUE_HEALTH_PLAN,
  [ScreeningStatus.FOLLOW_UP_NOT_STARTED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_FOLLOW_UP,
  [ScreeningStatus.FOLLOW_UP_INCOMPLETE]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_FOLLOW_UP,
  [ScreeningStatus.FOLLOW_UP_PENDING]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_FOLLOW_UP_PENDING,
  [ScreeningStatus.FOLLOW_UP_HANDLED]: CONTENTFUL_ENTRY_IDS.HOME_BANNER_CONTINUE_HEALTH_PLAN,
}

export const getHomeBannerEntryId = ({
  screeningStatus,
  isMaleUser,
  isManager,
}: {
  screeningStatus?: ScreeningStatus
  isMaleUser: boolean
  isManager?: boolean
}): ContentfulEntryId | undefined => {
  if (isMaleUser) {
    return isManager ? CONTENTFUL_ENTRY_IDS.HOME_BANNER_MANAGER_TRAINING : CONTENTFUL_ENTRY_IDS.HOME_BANNER_TRAINING
  }
  // Wait for the screening status rather than flashing the screening banner while it loads
  return screeningStatus && BANNER_BY_SCREENING_STATUS[screeningStatus]
}
